<!--
  Header height: the 88px desktop band is implied by the header's own content
  geometry — the 48px logo and the 32px "Sign out" pill, both centred via
  `flex items-center`, sit exactly at their intended y-offsets inside 88px
  ((88-48)/2=20, (88-32)/2=28).
  `#main`'s `top-*` MUST stay equal to this height, or content renders
  underneath the header.
  Mobile (`h-12`, 48px) is left as-is — no mobile chrome spec exists to size
  against (see the header component's own comments re: mobile).

  z-[25]: both this wrapper and `#main` below are `position: fixed`/`absolute`
  with no stacking context of their own, so DOM order alone decides the stacking —
  without an explicit z-index here, `#main` paints over the header, clipping any
  overflow from the header's own gradient scrim (seat-selection) as well as
  `app-viewer`'s own `:before` scrim (viewer.component.html), neither of which
  establishes a stacking context of its own either, so their z-index escapes
  all the way up to this level too. `z-[25]` clears both of those (`z-10`) and the map
  loader overlay (`z-20`, map-loader.component.html), so the header stays visible and clickable
  while the map loads, while
  staying below the seat-selection topbar's own map-controls row
  (viewer.component.html's `z-50` wrapper around `app-topbar`), which must stay
  clickable/visible above the header at all times.
-->
<div class="z-[25] fixed top-0 h-12 md:h-[88px] w-full">
  <app-header></app-header>
</div>

<!-- Loading screen -->
<!-- <app-loader></app-loader> -->

<!--
  `#main` top offset: everywhere else the page starts
  below the fixed header (`top-12`/`top-[88px]`). On seat-selection specifically
  it starts at `top-0` instead, so the DVM map genuinely renders behind the header's transparent
  gradient scrim (header.component.html's `showLegend` branch) rather than the header floating
  over an opaque plate standing in for the map. Seat-selection's own topbar/sidebar add their own
  top clearance to compensate (see viewer.component.html and sidebar.component.html) — this is
  the one route where the header is meant to overlap page content on purpose.
-->
<div
  id="main"
  class="w-full absolute bottom-0 overflow-auto"
  [ngClass]="isSeatSelectionRoute ? 'top-0' : 'top-12 md:top-[88px]'">
  <router-outlet></router-outlet>
</div>

<!-- Error -->
<!-- <app-error-modal></app-error-modal> -->
